import { createReducer } from '@reduxjs/toolkit';
import { v1 as uuidv1 } from 'uuid';

import { actions } from '../actions';

const initialState = [];

const reduceAddNotification = (variant, state, action) => {
    const payload = action.payload;
    let message = payload;
    let payloadOptions = {};

    if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        if (Object.prototype.hasOwnProperty.call(payload, 'message')) {
            message = payload.message;
        }
        if (Object.prototype.hasOwnProperty.call(payload, 'options')) {
            payloadOptions = payload.options || {};
        }
    }

    const options = {
        ...payloadOptions,
        variant,
    };

    // Warnings and errors should persist until manually closed unless overridden
    if ((variant === 'warning' || variant === 'error') && payloadOptions.persist === undefined) {
        options.persist = true;
    }

    return [
        ...state,
        {
            key: uuidv1(),
            message,
            options,
        },
    ];
};

const reduceRemoveNotification = (state, action) => {
    return state.filter((n) => n.key !== action.payload);
};

export const notification = createReducer(initialState, {
    [actions.notification.add.failure]: (state, action) => reduceAddNotification('error', state, action),
    [actions.notification.add.success]: (state, action) => reduceAddNotification('success', state, action),
    [actions.notification.add.warning]: (state, action) => reduceAddNotification('warning', state, action),
    [actions.notification.remove]: reduceRemoveNotification,
});
